import Table  from "../../../ui-elements/Table/Table";
import { insertDash } from "../../../services/utils";
import { mapToTableEntries } from "../../../services/pepWatchUtils";
import React from "react";
import { parsedFieldData, RowError, CreateDataTableProps } from "../../../types/PepTypes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faTimes } from "@fortawesome/pro-solid-svg-icons";

export const PepWatchUploadDataTable: React.FC<CreateDataTableProps> = ({ data, isInvalidData }) => {
  if (data.length === 0) return null;

  const tableData = isInvalidData ? (data as RowError[]).map((err) => err.originalRow) : (data as parsedFieldData[]);
  const red = "#DB0033"; // red	
  const green = "#038600"; // green

  const headerColor = isInvalidData ? red : green;
  const headerText = isInvalidData ? "Ógild gögn" : "Gild gögn";

  const mappedData = mapToTableEntries(tableData);

  return (
    <Table
      aSide={
        <h6 style={{ marginTop: 5, marginBottom: 10, color: headerColor }}>
          {headerText} ({data.length})
        </h6>
      }
      tableSize="sm"
      data={mappedData}
      withPagination="auto"
      paginationConfig={{ usePortal: true, itemsPerPage: 10 }}
      columns={[
        {
          title: "Kennitala",
          renderCell: ({ PersonId }) => insertDash(PersonId, ""),
          textAlign: "left",
          simpleSortable: (row) => row.PersonId ?? "",
        },
        {
          title: "Nafn",
          renderCell: ({ Name }) => Name,
          textAlign: "left",
          simpleSortable: (row) => row.Name ?? "",
        },
        {
          title: "Fæðingardagur",
          renderCell: ({ DateOfBirth }) => DateOfBirth,
          textAlign: "left",
          simpleSortable: (row) => {
            const date = row.DateOfBirth ? new Date(row.DateOfBirth) : null;
            return date ? date.getTime() : null;
          },
        },
        {
          title: "Land",
          renderCell: ({ CountryCode }) => CountryCode,
          textAlign: "left",
          simpleSortable: (row) => row.CountryCode ?? "",
        },
        {
          title: "Vöktun PEP",
          renderCell: ({ PepFrequency }) => (
            <FontAwesomeIcon
              icon={PepFrequency === "daily" ? faCheck : faTimes}
              style={{ color: PepFrequency === "daily" ? green : red }}
            />
          ),
          textAlign: "center",
          simpleSortable: (row) => row.PepFrequency ?? "",
        },
        {
          title: "Vöktun alþj. válistar",
          renderCell: ({ SanctionsFrequency }) => (
            <FontAwesomeIcon
              icon={SanctionsFrequency !== "never" ? faCheck : faTimes}
              style={{ color: SanctionsFrequency !== "never" ? green : red }}
            />
          ),
          textAlign: "center",
          simpleSortable: (row) => row.SanctionsFrequency ?? "",
        },
        {
          title: "Kyn",
          renderCell: ({ Gender }) => Gender === "Male" ? "Karl" : Gender === "Female" ? "Kona" : "",
          textAlign: "left",
          simpleSortable: ({ Gender }) => Gender === "Male" ? "Karl" : Gender === "Female" ? "Kona" : "",
        },
        {
          title: "Tilvísun",
          renderCell: ({ Reference  }) => {
            if(!Reference) return "";
            // If Reference is less than or equal to 10 characters, return it as is
            if (Reference.length < 11) {
              return Reference;
            } else {
              // Otherwise, return the first 10 characters followed by ellipsis
              return Reference.slice(0, 10) + "...";
            }
          },
          textAlign: "left",
          simpleSortable: (row) => row.Reference ?? "",
        },
      ]}
    />
  );
};
